'use strict';

module.exports = function isNotEmpty() {
  return !this.isEmpty();
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/isNotEmpty.js
// module id = 1671
// module chunks = 2